// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"71b1dd34","304":"2ed5f79c","453":"f9db1f37","501":"495d8fb7"}[chunkId] + ".chunk.js";
};